import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { updateSuccessMessage } from "../../../Messages/successMessages";
import { bidPackUrls } from "../../../URL/ApplicationUrls";
import { bidPackObjectName } from "../BidPack";
import { BidPackWriteRequest } from "../BidPackWriteRequest";
import { MdmApiError } from "../../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../../Errors/apiErrorNotificationToast";

export const useUpdateBidPack = (bidPackId: number | string | undefined) => {
  return useMutation({
    mutationFn: async (bidPack: BidPackWriteRequest) => {
      await axios.put(bidPackUrls.base.apiUrl, bidPack);
    },
    onSuccess: async () => toast.success(updateSuccessMessage(bidPackId, bidPackObjectName)),
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
